(() => {
  'use strict';
  const states = new WeakMap();
  async function jsonRequest(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 25000);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      const data = await response.json();
      if (!response.ok || data.status >= 400) {
        throw new Error(data.description || data.message || 'Não foi possível concluir a operação.');
      }
      return data;
    } finally { clearTimeout(timer); }
  }
  function setup(host) {
    if (states.has(host)) return states.get(host);
    const state = { busy: false, pendingCheckout: null };
    states.set(host, state);
    const primary = host.querySelector('.product-form__submit');
    const secondary = host.querySelector('[data-brinkae-add]');
    const sync = () => {
      secondary.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
      const label = primary.querySelector('.main-atc__label__text');
      if (!secondary.disabled && label && label.textContent.trim() !== 'Comprar agora') {
        label.textContent = 'Comprar agora';
      }
    };
    sync();
    new MutationObserver(sync).observe(primary, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    return state;
  }
  async function purchase(host, checkout) {
    const state = setup(host);
    const form = host.querySelector('form');
    const primary = host.querySelector('.product-form__submit');
    if (state.busy || primary.disabled || primary.getAttribute('aria-disabled') === 'true' || !form.reportValidity()) return;
    if (Number(primary.dataset.requiredFields || 0) > Number(primary.dataset.validFields || 0)) return;
    const status = host.querySelector('.brinkae-purchase-status');
    const cartLink = host.querySelector('.brinkae-cart-link');
    const secondary = host.querySelector('[data-brinkae-add]');
    clearTimeout(state.feedbackTimer);
    secondary.dataset.feedback = checkout ? '' : 'loading';
    secondary.textContent = checkout ? 'Adicionar ao carrinho' : 'Adicionando…';
    const data = new FormData(form);
    // Read the live native variant and quantity fields; retain custom properties and selling plans.
    const signature = JSON.stringify(Array.from(data.entries()));
    data.delete('sections');
    data.delete('sections_url');
    data.set('sections', 'cart-icon-bubble');
    data.set('sections_url', window.location.pathname);
    state.busy = true;
    host.setAttribute('aria-busy', 'true');
    status.hidden = false;
    cartLink.hidden = true;
    status.textContent = checkout ? 'Preparando sua compra…' : 'Adicionando ao carrinho…';
    let added = checkout && state.pendingCheckout === signature;
    try {
      if (!added) {
        const root = window.Shopify?.routes?.root || '/';
        const result = await jsonRequest(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        added = true;
        state.pendingCheckout = checkout ? signature : null;
        if (result.sections?.['cart-icon-bubble']) {
          const parsed = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
          const bubble = document.getElementById('cart-icon-bubble');
          const content = parsed.querySelector('.shopify-section');
          if (bubble && content) bubble.innerHTML = content.innerHTML;
        }
      }
      if (!checkout) {
        secondary.dataset.feedback = 'success';
        secondary.textContent = '✓ Adicionado ao carrinho';
        state.feedbackTimer = setTimeout(() => {
          secondary.dataset.feedback = '';
          secondary.textContent = 'Adicionar ao carrinho';
        }, 3000);
        status.textContent = 'Produto adicionado ao carrinho.';
        cartLink.hidden = false;
        return;
      }
      status.textContent = 'Abrindo checkout seguro…';
      const root = window.Shopify?.routes?.root || '/';
      const cart = await jsonRequest(root + 'cart.json');
      // LordPay: o checkout confere preço e disponibilidade direto na Shopify
      if (!window.LordPay || !cart.item_count) throw new Error('Checkout indisponível no momento.');
      window.location.assign(window.LordPay.checkoutUrl(cart));
    } catch (error) {
      secondary.dataset.feedback = '';
      secondary.textContent = 'Adicionar ao carrinho';
      status.textContent = added
        ? 'O produto está no carrinho, mas não foi possível abrir o checkout. Tente Comprar agora novamente ou acesse o carrinho.'
        : (error.name === 'AbortError' || error instanceof TypeError)
          ? 'Não foi possível confirmar a inclusão. Confira o carrinho antes de tentar novamente.'
          : error.message;
      cartLink.hidden = false;
    } finally {
      state.busy = false;
      host.removeAttribute('aria-busy');
    }
  }
  // Capture before the theme product-form handler to prevent duplicate additions and its /cart redirect.
  document.addEventListener('submit', event => {
    const host = event.target.closest('[data-brinkae-purchase]');
    if (!host) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    purchase(host, true);
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-brinkae-add], [data-brinkae-purchase] .product-form__submit');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    purchase(button.closest('[data-brinkae-purchase]'), !button.hasAttribute('data-brinkae-add'));
  }, true);
  function init() { document.querySelectorAll('[data-brinkae-purchase]').forEach(setup); }
  init();
  document.addEventListener('shopify:section:load', init);
})();


